import { render, staticRenderFns } from "./ReceptionistDashboard.vue?vue&type=template&id=2fd27198"
import script from "./ReceptionistDashboard.vue?vue&type=script&lang=js"
export * from "./ReceptionistDashboard.vue?vue&type=script&lang=js"
import style0 from "./ReceptionistDashboard.vue?vue&type=style&index=0&id=2fd27198&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports